interface JsonHighlightProps {
  data: unknown;
  maxHeight?: string;
}

function highlightJson(json: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  // Regex matches JSON tokens: strings, numbers, booleans, null, and structural chars
  const tokenRegex = /("(?:\\.|[^"\\])*")\s*:|("(?:\\.|[^"\\])*")|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)|(\btrue\b|\bfalse\b)|(\bnull\b)|([{}[\]:,])|(\s+)/g;

  let match: RegExpExecArray | null;
  let idx = 0;

  while ((match = tokenRegex.exec(json)) !== null) {
    const [full, key, str, num, bool, nul, structural, whitespace] = match;

    if (key !== undefined) {
      // key (string followed by colon) -- render key and colon separately
      nodes.push(
        <span key={idx++} className="text-ti-cyan">{key}</span>,
        <span key={idx++} className="text-ti-text-dim">: </span>
      );
    } else if (str !== undefined) {
      nodes.push(<span key={idx++} className="text-ti-green">{str}</span>);
    } else if (num !== undefined) {
      nodes.push(<span key={idx++} className="text-ti-amber">{num}</span>);
    } else if (bool !== undefined) {
      nodes.push(<span key={idx++} className="text-ti-purple">{bool}</span>);
    } else if (nul !== undefined) {
      nodes.push(<span key={idx++} className="text-ti-text-dim">{nul}</span>);
    } else if (structural !== undefined) {
      nodes.push(<span key={idx++} className="text-ti-text-dim">{structural}</span>);
    } else if (whitespace !== undefined) {
      nodes.push(<span key={idx++}>{whitespace}</span>);
    } else {
      nodes.push(<span key={idx++}>{full}</span>);
    }
  }

  return nodes;
}

export default function JsonHighlight({ data, maxHeight = '400px' }: JsonHighlightProps) {
  const json = JSON.stringify(data, null, 2);

  return (
    <pre
      className="bg-ti-bg rounded-lg p-4 overflow-auto custom-scrollbar text-sm leading-relaxed"
      style={{ maxHeight }}
    >
      <code className="font-mono">{highlightJson(json)}</code>
    </pre>
  );
}
